'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles_breakpoints = require('../../breakpoints-7bb24b2d.js');
var _extends = require('../../extends-f8003900.js');
var React = require('react');
var index = require('../../index-0e40e0c2.js');
var components_GlobalStyle_GlobalStyle = require('../GlobalStyle/GlobalStyle.js');
var styles_theme = require('../../theme-41bc4eaa.js');
var styled = require('styled-components');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../xstyled-styled-components.es-02f83f64.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var requireImageFunctionDefault = function requireImageFunctionDefault(imageSource) {
  return imageSource;
};
var NuDsContext = /*#__PURE__*/React.createContext({
  locale: '',
  formatMessage: function formatMessage(_ref) {
    var id = _ref.id;
    return id;
  },
  routerLinkComponent: undefined,
  backgroundImageFunction: undefined,
  requireImageFunction: requireImageFunctionDefault
});
var defaultPrimaryColorScheme = 'brand';

function NuDSProvider(_ref2) {
  var locale = _ref2.locale,
      formatMessage = _ref2.formatMessage,
      messages = _ref2.messages,
      routerLinkComponent = _ref2.routerLinkComponent,
      theme = _ref2.theme,
      colorScheme = _ref2.colorScheme,
      children = _ref2.children,
      requireImageFunction = _ref2.requireImageFunction,
      backgroundImageFunction = _ref2.backgroundImageFunction;

  var nuDSUpdatedTheme = _extends._extends({}, theme, {
    colors: _extends._extends({}, theme.colors, {
      primary: theme.colors[colorScheme]
    })
  });

  return /*#__PURE__*/React__default['default'].createElement(React.StrictMode, null, /*#__PURE__*/React__default['default'].createElement(NuDsContext.Provider, {
    value: {
      locale: locale,
      formatMessage: formatMessage,
      messages: messages,
      routerLinkComponent: routerLinkComponent,
      requireImageFunction: requireImageFunction,
      backgroundImageFunction: backgroundImageFunction
    }
  }, /*#__PURE__*/React__default['default'].createElement(styled.ThemeProvider, {
    theme: nuDSUpdatedTheme
  }, /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(components_GlobalStyle_GlobalStyle.GlobalFonts, null), /*#__PURE__*/React__default['default'].createElement(components_GlobalStyle_GlobalStyle['default'], null), children, /*#__PURE__*/React__default['default'].createElement("div", {
    id: "modal-root"
  })))));
}

var nuDSProviderShape = {
  backgroundImageFunction: index.PropTypes.func,
  children: index.PropTypes.node.isRequired,
  colorScheme: index.PropTypes.oneOf([].concat(styles_breakpoints.toConsumableArray(Object.keys(styles_theme.products)), [defaultPrimaryColorScheme])),
  formatMessage: index.PropTypes.func,
  locale: index.PropTypes.string,
  messages: index.PropTypes.objectOf(index.PropTypes.string),
  requireImageFunction: index.PropTypes.func,

  /** The component to be rendered when the href will be an internal path */
  routerLinkComponent: index.PropTypes.elementType,
  theme: index.PropTypes.objectOf(index.PropTypes.any)
};
NuDSProvider.propTypes = nuDSProviderShape;
NuDSProvider.defaultProps = {
  backgroundImageFunction: undefined,
  routerLinkComponent: undefined,
  theme: styles_theme.nuDSTheme,
  colorScheme: defaultPrimaryColorScheme,
  formatMessage: function formatMessage() {},
  requireImageFunction: requireImageFunctionDefault,
  locale: undefined,
  messages: {}
};

exports.NuDsContext = NuDsContext;
exports.default = NuDSProvider;
exports.defaultPrimaryColorScheme = defaultPrimaryColorScheme;
exports.nuDSProviderShape = nuDSProviderShape;
exports.requireImageFunctionDefault = requireImageFunctionDefault;
//# sourceMappingURL=NuDSProvider.js.map
